const r = {
  "cdr-label-wrapper": "cdr-label-wrapper_16-2-1",
  "cdr-label-wrapper__container": "cdr-label-wrapper__container_16-2-1",
  "cdr-label-wrapper--primary": "cdr-label-wrapper--primary_16-2-1",
  "cdr-label-wrapper--secondary": "cdr-label-wrapper--secondary_16-2-1",
  "cdr-label-wrapper--disabled": "cdr-label-wrapper--disabled_16-2-1",
  "cdr-label-wrapper__figure": "cdr-label-wrapper__figure_16-2-1",
  "cdr-label-wrapper__content": "cdr-label-wrapper__content_16-2-1",
  "cdr-label-wrapper--hide-figure": "cdr-label-wrapper--hide-figure_16-2-1",
  "cdr-checkbox__svg-box": "cdr-checkbox__svg-box_16-2-1",
  "cdr-label-wrapper--small": "cdr-label-wrapper--small_16-2-1",
  "cdr-label-wrapper--medium": "cdr-label-wrapper--medium_16-2-1",
  "cdr-label-wrapper--large": "cdr-label-wrapper--large_16-2-1",
  "cdr-checkbox__checkbox-box": "cdr-checkbox__checkbox-box_16-2-1",
  "cdr-label-wrapper--small@xs": "cdr-label-wrapper--small@xs_16-2-1",
  "cdr-label-wrapper--medium@xs": "cdr-label-wrapper--medium@xs_16-2-1",
  "cdr-label-wrapper--large@xs": "cdr-label-wrapper--large@xs_16-2-1",
  "cdr-label-wrapper--small@sm": "cdr-label-wrapper--small@sm_16-2-1",
  "cdr-label-wrapper--medium@sm": "cdr-label-wrapper--medium@sm_16-2-1",
  "cdr-label-wrapper--large@sm": "cdr-label-wrapper--large@sm_16-2-1",
  "cdr-label-wrapper--small@md": "cdr-label-wrapper--small@md_16-2-1",
  "cdr-label-wrapper--medium@md": "cdr-label-wrapper--medium@md_16-2-1",
  "cdr-label-wrapper--large@md": "cdr-label-wrapper--large@md_16-2-1",
  "cdr-label-wrapper--small@lg": "cdr-label-wrapper--small@lg_16-2-1",
  "cdr-label-wrapper--medium@lg": "cdr-label-wrapper--medium@lg_16-2-1",
  "cdr-label-wrapper--large@lg": "cdr-label-wrapper--large@lg_16-2-1",
  "cdr-checkbox": "cdr-checkbox_16-2-1",
  "cdr-checkbox__input": "cdr-checkbox__input_16-2-1"
};
export {
  r as default
};
